<template>
  <md-button id="button_scroll_to_top" v-if="scrollpx > 600" class="scroll-button md-primary md-round md-fab md-just-icon" @click="scrollToTop">
    <md-icon>expand_less</md-icon>
    <md-tooltip md-direction="left" :md-delay="1000">Наверх</md-tooltip>
  </md-button>
</template>

<script>
  export default {
    name: "ScrollButton",
    data() {
      return {
        scrollpx: 0
      };
    },
    methods: {
      scrollToTop() {
        window.scrollTo(0,0);
      },
      handleScroll() {
        this.scrollpx = window.scrollY;
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>

<style scoped>
  .scroll-button{
    position: fixed!important;
    right: 5px;
    bottom: 25px;
    z-index: 6;
  }
</style>